import React from 'react'
// @ts-ignore
import ReactStarRatings from 'react-star-ratings' // react-star-ratings is old, and do not have ts version

export interface IStarRatings {
  numberOfStars?: number
  color?: string
  size?: number
  spacing?: number
  rating: number | string
}

const StarRatings = ({ numberOfStars = 5, color = '#2257c5', size = 16, spacing = 0, rating }: IStarRatings) => {
  const adjustedRating = typeof rating === 'string' ? parseInt(rating) : rating

  return (
    <ReactStarRatings
      name='rating'
      numberOfStars={numberOfStars}
      rating={adjustedRating}
      starRatedColor={color}
      starDimension={`${size}px`}
      starSpacing={`${spacing}px`}
    />
  )
}

export default StarRatings
